import { render, staticRenderFns } from "./OpenSlopes.vue?vue&type=template&id=56e9db27"
import script from "./OpenSlopes.vue?vue&type=script&lang=js"
export * from "./OpenSlopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports